import './App.css';
import { Route, Routes } from 'react-router-dom';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Contact from './pages/Contact/Contact';
import Experience from './pages/Experience/Experience';
import HealthCareTech from './pages/HealthcareTech/HealthCareTech';
import Opportunity from './pages/Opportunity/Opportunity';
import Services from './pages/Services/Services';
import Team from './pages/Team/Team';
import Layout from './pages/Layout';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="contact" element={<Contact />} />
        <Route path="experience" element={<Experience />} />
        <Route path="healthcare-technology" element={<HealthCareTech />} />
        <Route path="opportunity" element={<Opportunity />} />
        <Route path="services" element={<Services />} />
        <Route path="team" element={<Team />} />
      </Route>
    </Routes>
  );
}

export default App;
